var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle2Pattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 646 289",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Circle Pattern 2 ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Images",
    strokeWidth: 1,
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-BG-Pattern-/-v1---White---25%",
    transform: "translate(0.000000, -73.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-BG-Pattern-/-v1---Lindab-Blue---25%",
    transform: "translate(0.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(525.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30115943,64.7153722 C8.5756333,34.1914645 33.2958985,9.45864566 64,8.98824614 L64,0 C28.4337018,0.75909018 0,29.6370686 0,65 C0,100.362931 28.4337018,129.24091 64,130 L64,120.712146 C33.2047753,120.207446 8.46088819,95.3312043 8.30115943,64.7153722 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,65.36516 C34.9892691,81.319854 47.8080419,94.4192461 64,95 L64,86.0106653 C52.8057987,85.5892726 43.9515935,76.5309148 43.9515935,65.5 C43.9515935,54.4690852 52.8057987,45.4107274 64,44.9893347 L64,36 C47.8655886,36.4693659 35.0258419,49.4707902 35,65.36516 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1688999,65.3496835 C26.2624173,44.463775 43.0455528,27.459002 64,27.0189873 L64,18 C38.3345016,18.9101018 18,39.9076849 18,65.5 C18,91.0923151 38.3345016,112.089898 64,113 L64,103.981013 C42.9422274,103.506609 26.1306851,86.3394574 26.1688999,65.3496835 L26.1688999,65.3496835 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,64.8648431 C120.936951,34.2597772 96.4399653,9.37757287 66,9 L66,17.5299008 C92.0692617,17.5299008 113.202574,38.7762646 113.202574,64.9849826 C113.202574,91.1937005 92.0692617,112.440064 66,112.440064 L66,121 C96.5241441,120.572624 121.035623,95.5552295 121,64.8648431 L121,64.8648431 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5817045,65.3795934 C94.571996,81.5027255 81.9073776,94.6941124 66,95.1501173 L66,104 C86.9868205,104 104,86.7629629 104,65.5 C104,44.2370371 86.9868205,27 66,27 L66,35.8197811 C81.8404225,36.2420021 94.4909552,49.3254546 94.5817045,65.3795934 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4726132,129.430744 C17.0172723,68.3829291 66.0715486,18.9172913 127,17.9764923 L127,0 C56.423127,1.51818036 0,59.2741372 0,130 C0,200.725863 56.423127,258.48182 127,260 L127,241.424291 C65.8907261,240.414893 16.789575,190.662409 16.4726132,129.430744 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,129.73032 C69.9789083,161.639708 95.1744272,187.838492 127,189 L127,171.021331 C104.997604,170.178545 87.5945113,152.06183 87.5945113,130 C87.5945113,107.93817 104.997604,89.8214547 127,88.9786694 L127,71 C95.2875362,71.9387318 70.0507926,97.9415804 70,129.73032 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3377998,129.699367 C52.5248346,87.92755 86.0911056,53.9180041 128,53.0379747 L128,35 C76.6690031,36.8202035 36,78.8153698 36,130 C36,181.18463 76.6690031,223.179796 128,225 L128,206.962025 C85.8844547,206.013218 52.2613702,171.678915 52.3377998,129.699367 L52.3377998,129.699367 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,129.729686 C240.873902,68.5195543 191.879931,18.7551457 131,18 L131,35.0598016 C183.138523,35.0598016 225.405148,77.5525292 225.405148,129.969965 C225.405148,182.387401 183.138523,224.880129 131,224.880129 L131,242 C192.048288,241.145247 241.071246,191.110459 241,129.729686 L241,129.729686 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.163409,129.759187 C188.143992,162.005451 162.814755,188.388225 131,189.300235 L131,207 C172.973641,207 207,172.525926 207,130 C207,87.4740743 172.973641,53 131,53 L131,70.6395622 C162.680845,71.4840041 187.98191,97.6509091 188.163409,129.759187 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2Pattern);
export default __webpack_public_path__ + "static/media/circle2-pattern.358f1af9.svg";
export { ForwardRef as ReactComponent };